import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-eleven',
  templateUrl: './home-eleven.component.html',
  styleUrls: ['./home-eleven.component.scss']
})
export class HomeElevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
